import { apiFetch } from "../utils/apiFetch"

export type EuipoDocumentKind =
  | "MARK_IMAGE"
  | "DESIGN_VIEW"
  | "PRIORITY_COPY"
  | "SENIORITY_COPY"

export async function uploadDocument(
  file: File,
  kind: EuipoDocumentKind
): Promise<{ euipoDocumentId: string; originalFileName: string }> {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("kind", kind)

  const res = await apiFetch("/api/documents/upload", {
    method: "POST",
    body: formData
  })

  return {
    euipoDocumentId: res.euipoDocumentId,
    originalFileName: res.originalFileName
  }
}
